const getCrypto = () => {
  if (typeof window !== 'undefined' && window.crypto) {
    return window.crypto
  }

  if (typeof global !== 'undefined' && global.crypto) {
    return global.crypto
  }

  return null
}

const generateWithGetRandomValues = (cryptoInstance) => {
  const bytes = new Uint8Array(16)
  cryptoInstance.getRandomValues(bytes)

  // Set version (4) and variant bits
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80

  const toHex = (num) => num.toString(16).padStart(2, '0')

  return [
    toHex(bytes[0]),
    toHex(bytes[1]),
    toHex(bytes[2]),
    toHex(bytes[3]),
    '-',
    toHex(bytes[4]),
    toHex(bytes[5]),
    '-',
    toHex(bytes[6]),
    toHex(bytes[7]),
    '-',
    toHex(bytes[8]),
    toHex(bytes[9]),
    '-',
    toHex(bytes[10]),
    toHex(bytes[11]),
    toHex(bytes[12]),
    toHex(bytes[13]),
    toHex(bytes[14]),
    toHex(bytes[15]),
  ].join('')
}

const generateFallbackUuid = () => {
  const timestampPart = Date.now().toString(36)
  const randomPart = Math.random().toString(36).slice(2, 10)
  return `temp-${timestampPart}-${randomPart}`
}

const generateUuid = () => {
  const cryptoInstance = getCrypto()

  if (cryptoInstance?.randomUUID) {
    return cryptoInstance.randomUUID()
  }

  if (cryptoInstance?.getRandomValues) {
    return generateWithGetRandomValues(cryptoInstance)
  }

  return generateFallbackUuid()
}

export default generateUuid
